module.exports = __webpack_public_path__ + "static/media/header-2.124cf6d4.png";